import React, { PropsWithChildren } from "react";
import { cn } from "@/lib/utils";
import { BackgroundColor, Tag } from "@silversea-ssc/ui-components-react";
import styles from "./Tags.module.scss";
import { isPresent } from "@/lib/checks";

type TagsProps = {
  tags: { _id: string; title: string | undefined }[];
  backgroundColor?: BackgroundColor;
} & React.ComponentProps<"ul">;

const Tags: React.FC<TagsProps> = ({ tags, backgroundColor, className }) => {
  if (!tags) return null;

  return (
    <TagsList className={className}>
      {tags.filter(isPresent).map((tag) => (
        <li key={tag._id}>
          <Tag backgroundColor={backgroundColor || "neutral10"}>
            {tag?.title}
          </Tag>
        </li>
      ))}
    </TagsList>
  );
};

export const TagsList: React.FC<
  PropsWithChildren<React.ComponentProps<"ul">>
> = ({ children, className }) => {
  return <ul className={cn(styles.list, className)}>{children}</ul>;
};

export default Tags;
